export default __webpack_public_path__ + "static/media/background-footer.c47b4f5c.png";